import { Debug } from '@hh.ru/browser-api-utils';

export default Debug;
